import React from 'react';
import {ENV} from "../../services/env";
import "./contentBox.css"
import { useHistory } from "react-router-dom"
const ContentBox  = (props) => {
    const history = useHistory()
    return (
        <div className="content_box">
           <div className="content_box_image">
               {
                   props.type === "video" ?
                       <video loop muted playsInline preload="auto" controls>
                           <source src={ENV.API.IMG + props.file + "#t=0.005"}/>
                       </video>
                       :
                       props.image && <img alt="blog" src={ENV.API.IMG + props.image}/>
               }
           </div>
            <div  className="content_box_detail">
                <div className="content_box_title">
                    <div>
                        <a>{props.title.substr(0,30)}</a>
                    </div>
                </div>
                <div  className="content_box_des" dangerouslySetInnerHTML={{__html:props.description}}/>
                <div className="more_btn">
                    <div onClick={() => {history.push(`/${props.route}/${props.id}`,{props})}}>
                        <a>ادامه مطلب</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentBox ;
